export const UTM_TAG_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export const UTM_TAG_KEY_SET = new Set(UTM_TAG_KEYS);
